export default "__VITE_ASSET__CtY_4_B6__"